<dx-form [formData]="formData" id="form">
  <dxi-item dataField="justificationPermissionBox"
            editorType="dxSelectBox"
            [label]="{ text: 'Tipo di Richiesta' }"
            [editorOptions]="{
             items: causalOptions,
             displayExpr: displayCausal,
             placeholder: 'Seleziona tipologia richiesta',
             disabled: tipologiaDisabled,
            elementAttr: { style: 'background-color: white; color: black'}
           }"
            caption="Tipo richiesta">
    <dxi-validation-rule type="required" message="Il tipo di richiesta è obbligatorio"></dxi-validation-rule>
  </dxi-item>

  <dx-select-box [value]="formData.justificationPermissionBox"
                 [items]="causalOptions"
                 (onValueChanged)="onTypeChange($event.value)">
  </dx-select-box>

  <!-- Campi ferie -->
  <dxi-item dataField="startDay" editorType="dxDateBox"
            [label]="{ text: 'Primo Giorno Ferie' }"
            [editorOptions]="{ type: 'date',
                               onValueChanged: onStartDayChanged,
                               disabled: controlsDisabled,

                              elementAttr: { style: 'background-color: white; color: black'}}"
            [visible]="isFerie"
            caption="Data di inizio">
    <dxi-validation-rule type="required"
                         message="La data di inizio è obbligatoria">
    </dxi-validation-rule>
    <dxi-validation-rule type="async"
                         [validationCallback]="validateStartDayAsync">
    </dxi-validation-rule>
  </dxi-item>
  <dxi-item dataField="endDay" editorType="dxDateBox"
            [label]="{ text: 'Ultimo Giorno Ferie' }"
            [editorOptions]="{ type: 'date',
                               disabled: controlsDisabled,

                              elementAttr: { style: 'background-color: white; color: black'}}"
            [visible]="isFerie"
            caption="Data di fine">
    <dxi-validation-rule type="required"
                         message="Il data di fine è obbligatoria">
    </dxi-validation-rule>
    <dxi-validation-rule type="async"
                         [validationCallback]="validateEndDayAsync">
    </dxi-validation-rule>
  </dxi-item>

  <!-- Campi permesso -->
  <dxi-item dataField="day" editorType="dxDateBox"
            [label]="{ text: 'Giorno' }"
            [editorOptions]="{ type: 'date',
                               disabled: controlsDisabled,

                              elementAttr: { style: 'background-color: white; color: black'}}"
            [visible]="!isFerie"
            caption="Data">
    <dxi-validation-rule type="required"
                         message="La data è obbligatoria">
    </dxi-validation-rule>
  </dxi-item>

  <dxi-item dataField="startTimeString"
            editorType="dxDateBox"
            [label]="{ text: 'Ora di inizio' }"
            [editorOptions]="{
             type: 'time',
             displayFormat: 'HH:mm',
             value: formData.startTimeString,
             disabled: controlsDisabled,

            elementAttr: { style: 'background-color: white; color: black'}
           }"
            [visible]="!isFerie"
            caption="Ora di inizio">
    <dxi-validation-rule type="required" message="L'ora di inizio è obbligatoria"></dxi-validation-rule>
  </dxi-item>

  <dxi-item dataField="endTimeString"
            editorType="dxDateBox"
            [label]="{ text: 'Ora di fine' }"
            [editorOptions]="{
             type: 'time',
             displayFormat: 'HH:mm',
             value: formData.endTimeString,
             disabled: controlsDisabled,

            elementAttr: { style: 'background-color: white; color: black'}
           }"
            [visible]="!isFerie"
            caption="Ora di fine">
    <dxi-validation-rule type="required" message="L'ora di fine è obbligatoria"></dxi-validation-rule>
  </dxi-item>



  <dxi-item dataField="causal"
            editorType="dxSelectBox"
            [label]="{ text: 'Causale' }"
            [editorOptions]="{
              items: staticCausalOptions,
              displayExpr: 'text',
              valueExpr: 'text',
              placeholder: 'Seleziona causale',
              disabled: isCausalSelectDisabled,

            elementAttr: { style: 'background-color: white; color: black'}
            }"
            caption="Causale">
    <!--<dxi-validation-rule type="required"
                         message="La causale è obbligatoria">
    </dxi-validation-rule> -->
  </dxi-item>
  <!-- Bottone invio -->
  @if(sendEnabled){
  <dxi-item itemType="button" [buttonOptions]="registerButtonOptions"></dxi-item>
  }

  @if(deleteEnabled){
  <dxi-item itemType="button" [buttonOptions]="deletePermission"></dxi-item>
  }
</dx-form>
